import { render, staticRenderFns } from "./ProfileChangeEmail.vue?vue&type=template&id=1616a16a&"
import script from "./ProfileChangeEmail.vue?vue&type=script&lang=js&"
export * from "./ProfileChangeEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports